<template>
  <div class="st-svg" :style="{maxWidth: maxWidth}"></div>
</template>

<script>
export default {
  props: ['rootFolder', 'platform', 'maxWidth'],
  data () {
    return {
      svgElem: null,
      originalAspectRatio: 1
    }
  },
  mounted () {
    this.$loading.withLoading(this.fetchXML)()
  },
  destroyed () {
    window.removeEventListener('resize', this.onPageResize)
  },
  methods: {
    fetchXML () {
      return fetch(require(`images/${this.rootFolder}/${this.platform}.svg`))
      .then(res => res.text())
      .then((xml) => {
        var xmlNode = new DOMParser().parseFromString(xml, 'image/svg+xml')
        this.svgElem = this.$el.appendChild(this.processSvg(xmlNode))
        this.$emit('onGetSvg', this.svgElem)
        this.onPageResize()
        window.addEventListener('resize', this.onPageResize)
      }).catch(err => console.log(err))
    },
    processSvg (xml, i) {
      // var svgNode
      // if (navigator.appName === 'Microsoft Internet Explorer') {
      //   svgNode = this.cloneToDoc(xml.documentElement)
      // } else {
      var svgNode = document.importNode(xml.documentElement, true)
      // }
      var [,, originalWidth, originalHeight] = svgNode.getAttribute('viewBox').split(' ')
      this.originalAspectRatio = originalHeight / originalWidth
      // svgNode.setAttribute('preserveAspectRatio', 'xMidYMid meet')

      Array.from(svgNode.querySelectorAll('image')).forEach(img => img.setAttribute('xlink:href', require(`images/${this.rootFolder}/${img.getAttribute('xlink:href')}`)))
      // return svgNode.outerHTML
      return svgNode
    },
    // cloneToDoc (node) {
    //   var clone = document.createElementNS(node.namespaceURI, node.nodeName)
    //   for (var i = 0, len = node.attributes.length; i < len; ++i) {
    //     var a = node.attributes[i]
    //     if (/^xmlns\b/.test(a.nodeName)) continue // IE can't create these
    //     clone.setAttributeNS(a.namespaceURI, a.nodeName, a.nodeValue)
    //   }
    //   for (var ii = 0, len2 = node.childNodes.length; ii < len2; ++ii) {
    //     var c = node.childNodes[ii]
    //     clone.insertBefore(
    //       c.nodeType === 1 ? this.cloneToDoc(c) : document.createTextNode(c.nodeValue),
    //       null
    //     )
    //   }
    //   return clone
    // },
    onPageResize () {
      var newWidth = this.$el.clientWidth
      var newHeight = newWidth * this.originalAspectRatio
      this.svgElem.style.width = newWidth + 'px'
      this.svgElem.style.height = newHeight + 'px'
    }
  }
}
</script>

<style lang="scss">
.st-svg {
  margin: 0 auto;
}
</style>
